import React from "react";
import {
  Col,
  Row,
  Label,
} from "reactstrap";

export default function UsersList({
  usersList,
  openEditUser,
  openCopyUser,
  openDialogDeleteUser,
}) {
  const getProfileText = React.useCallback((profile = '') => {
    switch (profile) {
      case 'admin':
        return 'Administrador';
        break;
      case 'staff':
        return 'Staff';
        break;
      case 'controller':
        return 'Controlador';
        break;
      default:
        return 'Administrador';
        break;
    }
  })

  if (usersList.length <= 0) {
    return (
      <div style={{ paddingBottom: '10px' }}>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <div>
              <Label htmlFor="formFile" className="form-label">
                {`Não há usuários cadastrados`}
              </Label>
            </div>
          </Col>
        </Row>
      </div>
    )
  }
  return (
    <div style={{ paddingBottom: '10px' }}>
      {usersList.map(user => {
        return (
          <div key={user.ID}>
            <Row style={{ padding: 2, justifyContent: 'center' }}>
              <div
                style={{
                  backgroundColor: 'white',
                  borderRadius: 5,
                  padding: 5,
                  boxShadow: '0px 0px 2px #3b3a3a',
                  shadowOpacity: 0.25,
                  shadowRadius: 3.84,
                  elevation: 5,
                  justifyContent: "center",
                  backgroundColor: '#f5f5f5',
                }}
              >
                <div style={{ paddingBottom: 5, flexDirection: 'row', display: 'flex' }}>
                  <i className="mdi mdi-account" style={{ paddingRight: 15 }} />
                  <Label htmlFor="formFile" className="form-label">
                    {getProfileText(user.Perfil)}
                  </Label>
                </div>
                <div style={{ paddingBottom: 5, flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <spam style={{ fontWeight: 'bold' }}>
                      Nome
                    </spam>
                    <spam>
                      {user.Nome}
                    </spam>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <spam style={{ fontWeight: 'bold' }}>
                      Login
                    </spam>
                    <spam>
                      {user.Login}
                    </spam>
                  </div>
                </div>
                <div style={{ paddingBottom: 5, flexDirection: 'column', display: 'flex' }}>
                  <spam style={{ fontWeight: 'bold' }}>
                    Email
                  </spam>
                  <spam>
                    {user.Email}
                  </spam>
                </div>
                <div style={{ paddingBottom: 5, flexDirection: 'row', display: 'flex', justifyContent: 'flex-end' }}>
                  <i className="mdi mdi-file-edit" style={{ paddingRight: 15, fontSize: 20, cursor: 'pointer' }} onClick={() => openEditUser(user)} />
                  <i className="mdi mdi-content-copy" style={{ paddingRight: 15, fontSize: 20, cursor: 'pointer' }} onClick={() => openCopyUser(user)} />
                  <i className="mdi mdi-delete-outline" style={{ paddingRight: 15, fontSize: 20, cursor: 'pointer', color: 'red' }} onClick={() => openDialogDeleteUser(user)} />
                </div>
              </div>
            </Row>
          </div>
        )
      })}
    </div>
  )
}
